import { END_POINTS } from "../constants/urls";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const storeApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addStore: builder.mutation<CommonResponseType & { data?: any }, any>({
      query: (body) => ({
        url: END_POINTS.store,
        method: "POST",
        body,
      }),
      invalidatesTags: ["STORES"],
    }),
    updateStore: builder.mutation<
      CommonResponseType & { data?: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.store}${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, arg) => [
        "STORES",
        { type: "STORES", id: arg.id } as any,
      ],
    }),
    getStoreList: builder.query<
      CommonResponseType & {
        data: {
          store: any[];
          count: number;
        };
      },
      {
        page: number;
        limit: number;
        search?: string;
        status?: string;
      }
    >({
      query: ({ page, limit, search, status }) => ({
        url: `${END_POINTS.store}list/?page=${page}&limit=${limit}${search ? `&search=${search}` : ""
          }${status !== "2" ? `&status=${status}` : ""}&sortBy=storeCode&sortOrder=asc`,
        method: "GET",
      }),
      providesTags: (result) => {
        const baseTag: any[] = ["STORES"];
        const items = (result as any)?.data?.store || [];
        const list = Array.isArray(items) ? items : items?.list || [];
        const idTags = list
          .map((item: any) => item?._id || item?.id)
          .filter(Boolean)
          .map((id: string) => ({ type: "STORES", id } as any));
        return baseTag.concat(idTags);
      },
    }),
    getStoreById: builder.query<
      CommonResponseType & { data: any },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.store}${id}`,
        method: "GET",
      }),
      providesTags: (result, error, arg) => [
        { type: "STORES", id: arg.id } as any,
      ],
    }),
    deleteStore: builder.mutation<
      CommonResponseType & { data?: any },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.store}${id}`,
        method: "DELETE",
        body: {},
      }),
      invalidatesTags: (result, error, arg) => [
        "STORES",
        { type: "STORES", id: arg.id } as any,
      ],
    }),
  }),
});

export const {
  useAddStoreMutation,
  useUpdateStoreMutation,
  useLazyGetStoreListQuery,
  useGetStoreByIdQuery,
  useLazyGetStoreByIdQuery,
  useDeleteStoreMutation,
} = storeApi;
